function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'faded-berry': 'rgb(210, 61, 117)','faded-khaki': 'rgb(151, 135, 89)','faded-denim-blue': 'rgb(90, 88, 135)','pastel-pink': 'rgb(238, 204, 225)','charcoal': 'rgb(47, 44, 48)','washed-black': 'rgb(55, 53, 62)','stone': 'rgb(237, 234, 234)','french-navy': 'rgb(48, 41, 87)','washed-green': 'rgb(78, 94, 92)','washed-grey': 'rgb(127, 129, 131)','off-white': 'rgb(235, 231, 239)','pink-mauve': 'rgb(233, 197, 210)','sea-green': 'rgb(187, 208, 224)','vintage-green': 'rgb(163, 187, 172)','vintage-black': 'rgb(34, 33, 36)','vintage-denim': 'rgb(49, 81, 107)','vintage-white': 'rgb(240, 238, 237)','slate': 'rgb(41, 38, 41)','denim-blue': 'rgb(39, 60, 87)','vintage-blue': 'rgb(54, 85, 115)','marl-grey': 'rgb(188, 190, 192)','sage-green': 'rgb(136, 190, 172)','cool-green': 'rgb(181, 216, 213)','white-mist': 'rgb(247, 245, 244)','peachy-pink': 'rgb(238, 208, 193)','sand': 'rgb(229, 212, 206)','olive-green': 'rgb(141, 130, 74)','light-turquoise': 'rgb(203, 235, 249)','teal': 'rgb(136, 191, 208)','teal-green': 'rgb(122, 185, 191)','candy-pink': 'rgb(239, 211, 218)','lilac': 'rgb(182, 181, 202)','mint-green': 'rgb(190, 217, 220)','washed-charcoal': 'rgb(94, 91, 94)','khaki': 'rgb(130, 124, 94)','washed-navy': 'rgb(95, 116, 145)','washed-red': 'rgb(178, 88, 112)','washed-olive': 'rgb(110, 117, 101)','washed-aqua': 'rgb(108, 158, 232)','washed-pink': 'rgb(250, 209, 222)','washed-orange': 'rgb(255, 116, 112)','washed-light-blue': 'rgb(189, 210, 253)','washed-ochre': 'rgb(253, 202, 124)','washed-sea-green': 'rgb(161, 177, 188)','washed-forest-green': 'rgb(22, 110, 101)','washed-stone': 'rgb(243, 233, 225)','light-pink': 'rgb(249, 202, 167)','orange': 'rgb(251, 148, 51)','navy': 'rgb(25, 32, 55)','burnt-orange': 'rgb(248, 82, 51)','dark-green': 'rgb(10, 54, 51)','burgundy': 'rgb(93, 4, 20)','pistachio': 'rgb(187, 180, 168)','marled-grey': 'rgb(184, 179, 180)','faded-denim': 'rgb(101, 127, 177)','washed-navy': 'rgb(67, 72, 127)','heather-grey': 'rgb(142, 142, 140)','bottle-green': 'rgb(0, 57, 42)','dusky-lilac': 'rgb(206, 185, 190)',};

    this.images = {'black-with-white': 'url("//hager-vor.co.uk/cdn/shop/files/Black_with_White_68x.jpg?v=17618371214342735368")','navy-with-white': 'url("//hager-vor.co.uk/cdn/shop/files/Navy_with_White_68x.jpg?v=11004271426457966742")','marl-grey-with-green': 'url("//hager-vor.co.uk/cdn/shop/files/Marl_Grey_with_Green_68x.jpg?v=4943768563375184526")','marl-grey-with-blue': 'url("//hager-vor.co.uk/cdn/shop/files/Marl_Grey_with_Blue_68x.jpg?v=4000544701489494980")','black-with-black': 'url("//hager-vor.co.uk/cdn/shop/files/Black_with_Black_68x.jpg?v=17788700837584750533")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
